module.exports = __webpack_public_path__ + "static/media/031.10901d3d.jpg";